import FormikRadioButtonInput from "../../../../../helpers/formikInputs/FormikRadioButtonInput"
import elementTypes from "../Elements/elementTypes"

export default function QuestionOptionAlignment({
  formikQuestionName,
  questionType,
  disabled,
}) {
  let label = "Option alignment"
  let options = [
    { label: "Vertical", value: "vertical" },
    { label: "Horizontal", value: "horizontal" },
  ]

  if (
    [elementTypes.headingElementId, elementTypes.descriptionElementId].includes(
      questionType
    )
  ) {
    label =
      elementTypes.headingElementId === questionType
        ? "Heading alignment"
        : "Description alignment"
    options = [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" },
    ]
  }

  return (
    <FormikRadioButtonInput
      name={`${formikQuestionName}.optionAlignment`}
      label={label}
      options={options}
      optionLabel={"label"}
      optionValue={"value"}
      useSelectButton={true}
      disabled={disabled}
    />
  )
}
